var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 82,
    viewBox: "0 0 67 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8493 17.9042C11.221 17.9042 9.90425 19.221 9.90425 20.8493V26.7535C9.90425 28.3818 8.58039 29.6986 6.95212 29.6986C5.32385 29.6986 4 28.3818 4 26.7535V20.8493C4 15.9645 7.96448 12 12.8493 12H18.7535C20.3818 12 21.6986 13.3239 21.6986 14.9521C21.6986 16.5804 20.3818 17.9042 18.7535 17.9042H12.8493Z",
    fill: "#00A100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.151 65.0957C55.7793 65.0957 57.0961 63.779 57.0961 62.1507V56.2464C57.0961 54.6182 58.4199 53.3014 60.0482 53.3014C61.6765 53.3014 63.0003 54.6182 63.0003 56.2464V62.1507C63.0003 67.0355 59.0359 71 54.151 71H48.2468C46.6185 71 45.3018 69.6761 45.3018 68.0479C45.3018 66.4196 46.6185 65.0957 48.2468 65.0957H54.151Z",
    fill: "#00A100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0961 20.8493C57.0961 19.221 55.7793 17.9042 54.151 17.9042H48.2468C46.6185 17.9042 45.3018 16.5804 45.3018 14.9521C45.3018 13.3239 46.6185 12 48.2468 12H54.151C59.0359 12 63.0003 15.9645 63.0003 20.8493V26.7535C63.0003 28.3818 61.6765 29.6986 60.0482 29.6986C58.4199 29.6986 57.0961 28.3818 57.0961 26.7535V20.8493Z",
    fill: "#00A100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8493 65.0958C11.221 65.0958 9.90425 63.779 9.90425 62.1507V56.2465C9.90425 54.6182 8.58039 53.3014 6.95212 53.3014C5.32385 53.3014 4 54.6182 4 56.2465V62.1507C4 67.0355 7.96448 71 12.8493 71H18.7535C20.3818 71 21.6986 69.6762 21.6986 68.0479C21.6986 66.4196 20.3818 65.0958 18.7535 65.0958H12.8493Z",
    fill: "#00A100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6976 23.8014C18.4411 23.8014 15.8005 26.442 15.8005 29.6986V38.5479H9.9033C8.27503 38.5479 6.95117 39.8717 6.95117 41.5C6.95117 43.1282 8.26795 44.4521 9.9033 44.4521H57.0948C58.7231 44.4521 60.0469 43.1282 60.0469 41.5C60.0469 39.8717 58.7231 38.5479 57.0948 38.5479H51.1976V29.6986C51.1976 26.442 48.557 23.8014 45.3005 23.8014H21.6976Z",
    fill: "#00A100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.198 47.3972H15.8008V53.3015C15.8008 56.558 18.4414 59.1986 21.6979 59.1986H45.3008C48.5573 59.1986 51.198 56.558 51.198 53.3015V47.3972Z",
    fill: "#00A100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFour);
export default __webpack_public_path__ + "static/media/four.a6424b201d6bb2bbead19afef4a8e2a9.svg";
export { ForwardRef as ReactComponent };